import { FontWeight, ITheme } from '@quicktools/shared-components/styles';
import { createUseStyles } from 'react-jss';

const useCommonStyles = createUseStyles(
  ({ colors }: ITheme) => ({
    inputClassName: {
      marginTop: 4,
      padding: [12, 16],
      width: '100%',
      backgroundColor: 'var(--x-bg-12)',
      border: '2px solid var(--x-border-1)',
      borderRadius: 12,
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: FontWeight.Medium,
      color: colors.black,
      outline: 'none',

      '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:active,&:-webkit-autofill:focus':
        {
          boxShadow: `0 0 0 1000px white inset !important`,
        },
      '&::-webkit-contacts-auto-fill-button': {
        display: 'none !important',
        visibility: 'hidden',
      },
    },

    inputError: {
      border: '2px solid var(--x-error-color)',
    },

    inputWarning: {
      border: '2px solid var(--x-new-label-color)',
    },

    messageIcon: {
      marginRight: 2,
      verticalAlign: 'sub',
    },

    messageText: {
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: FontWeight.SemiBold,
      color: 'var(--x-error-color)',
    },

    warning: {
      color: 'var(--x-new-label-color)',
    },
    errorContainer: {
      marginTop: 4,
    },
  }),
  { name: 'form-sections' },
);
export default useCommonStyles;
